import styled from "@emotion/styled";
import {Button} from "@mui/material";

export const PureButton = styled.button`
	border: 0;
	padding: 0;
	margin: 0;
	background: none;
	cursor: pointer;

	&:disabled {
		cursor: initial;
	}
`;

export const BaseButton = styled(Button)`
	padding: 0;
	margin: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	min-width: unset;
`;

export const PrimaryButton = styled(Button)`
	font-family: "Khand", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	display: flex;
	align-items: center;
	text-transform: uppercase;
	transition: 0.25s;
	border: 1px solid ${({theme}) => theme.buttons.primary.default.borderColor};
	background: ${({theme}) => theme.buttons.primary.default.background};
	color: ${({theme}) => theme.buttons.primary.default.color};
	padding: 13px 16px;
	border-radius: 4px;
	line-height: 120%;

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.primary.hover.background};
		color: ${({theme}) => theme.buttons.primary.hover.color};
		border-color: ${({theme}) => theme.buttons.primary.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.primary.disabled.background};
		color: ${({theme}) => theme.buttons.primary.disabled.color};
		opacity: ${({theme}) => theme.buttons.primary.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.primary.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}

	&.wide {
		min-width: 320px;
		width: 100%;
	}

	&.medium {
		min-width: 200px;
		width: 100%;
	}
`;

export const SecondaryButton = styled(PrimaryButton)`
	background: ${({theme}) => theme.buttons.secondary.default.background};
	color: ${({theme}) => theme.buttons.secondary.default.color};
	border-color: ${({theme}) => theme.buttons.secondary.default.borderColor};

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.secondary.hover.background};
		color: ${({theme}) => theme.buttons.secondary.hover.color};
		border-color: ${({theme}) => theme.buttons.secondary.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.secondary.disabled.background};
		color: ${({theme}) => theme.buttons.secondary.disabled.color};
		opacity: ${({theme}) => theme.buttons.secondary.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.secondary.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}

	&.wide {
		min-width: 320px;
		width: 100%;
	}

	&.medium {
		min-width: 200px;
		width: 100%;
	}
`;

export const PrimaryDarkButton = styled(PrimaryButton)`
	background: ${({theme}) => theme.buttons.primaryDark.default.background};
	color: ${({theme}) => theme.buttons.primaryDark.default.color};
	border-color: ${({theme}) => theme.buttons.primaryDark.default.borderColor};

	&:hover,
	&:focus,
	&:active,
	&.active {
		background: ${({theme}) => theme.buttons.primaryDark.hover.background};
		color: ${({theme}) => theme.buttons.primaryDark.hover.color};
		border-color: ${({theme}) => theme.buttons.primaryDark.hover.borderColor};
		cursor: pointer;
	}

	&:disabled {
		background: ${({theme}) => theme.buttons.primaryDark.disabled.background};
		color: ${({theme}) => theme.buttons.primaryDark.disabled.color};
		opacity: ${({theme}) => theme.buttons.primaryDark.disabled.opacity};
		border-color: ${({theme}) => theme.buttons.primaryDark.disabled.borderColor};
		pointer-events: none;
		cursor: default;
	}

	&.wide {
		min-width: 320px;
		width: 100%;
	}

	&.medium {
		min-width: 200px;
		width: 100%;
	}
`;
